module.exports = __webpack_public_path__ + "ru.svg?af31e644412f6079d91279ae7b977196";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ru.svg
// module id = 1335
// module chunks = 0